<template>
  <div class="main-area">
    <main>
      <section class="main-title">
        <h1>チャレンジ情報閲覧</h1>
      </section>

      <!-- チャレンジ情報-->
      <section v-if="!challenge.is_sponser || challenge.id !== 243" class="article-container">
        <article class="white-block reading-block">
          <!-- メインビジュアル画像 -->
          <div class="reading-visual">
            <template v-if="challenge.presigned_challenge_main_image_url">
              <a class="img-box" :href="challenge.presigned_challenge_main_image_url"
                data-lightbox="challenge_image" :data-title="challenge.main_image_title">
                <img
                  :src="challenge.presigned_challenge_main_image_url"
                  :alt="challenge.presigned_challenge_main_image_filename">
              </a>
              <div class="reading-visual-caption">{{ challenge.main_image_title }}</div>
            </template>
            <template v-else>
              <a class="img-box" href="#">
                <img
                  src="~images/image_default.jpg"
                  alt="デフォルト画像"
                />
              </a>
            </template>
          </div>
          <!-- 投稿日時 -->
          <div class="reading-bar">
            <small class="reading-date text-secondary">{{ challenge.release_at | format.datetime }}</small>
          </div>
          <!-- タイトル -->
          <h2 class="reading-title">{{ challenge.title }}</h2>
          <!-- 最新情報企業 -->
          <dl class="reading-body border-bottom">
            <dt>
              <img v-if="challenge.is_challenge_manager_image"
                :src="challenge.presigned_challenge_manager_image_url"
                :alt="challenge.presigned_challenge_manager_image_filename"
                class="thumbnail-frame img40"
              />
              <img v-else
                src="~images/ep_user_default.png"
                alt="画像が選択されていません"
                class="thumbnail-frame img40"
              />
            </dt>
            <dd>
              <p class="company-name">{{ challenge.ep_company_name_department_name }}</p>
            </dd>
          </dl>
          <dl class="reading-item">
            <dt>私たちのチャレンジ</dt>
            <dd class="u-pre-wrap" v-html="challenge.detail"></dd>
          </dl>
          <dl class="reading-item" v-if="challenge.sub1_image_id || challenge.sub2_image_id">
            <dt>イメージ</dt>
            <dd class="d-flex">
              <!-- 画像（サブビジュアル1） -->
              <figure v-if="challenge.sub1_image_id">
                <a class="img-box" :href="challenge.presigned_challenge_sub1_image_url"
                  data-lightbox="challenge_image" :data-title="challenge.sub1_image_title">
                  <img
                    :src="challenge.presigned_challenge_sub1_image_url"
                    :alt="challenge.presigned_challenge_sub1_image_filename"
                  >
                </a>
                <figcaption class="reading-visual-caption">{{ challenge.sub1_image_title }}</figcaption>
              </figure>
              <!-- 画像（サブビジュアル2） -->
              <figure class="mr-3" v-if="challenge.sub2_image_id">
                <a class="img-box" :href="challenge.presigned_challenge_sub2_image_url"
                  data-lightbox="challenge_image" :data-title="challenge.sub2_image_title">
                  <img
                    :src="challenge.presigned_challenge_sub2_image_url"
                    :alt="challenge.presigned_challenge_sub2_image_filename"
                  >
                </a>
                <figcaption class="reading-visual-caption">{{ challenge.sub2_image_title }}</figcaption>
              </figure>
            </dd>
          </dl>
          <dl class="reading-item">
            <dt>パートナー企業様にご提供できる価値</dt>
            <dd>
              <template v-if="challenge.is_show_more_assets">
                <div v-for="asset in challenge.asset_masters.slice(0, 10)" :key="asset.asset_master_id" class="task-labels">
                  <p class="task-labels-parent">
                    {{ asset.name }}
                  </p>
                </div>
                <div class="btn-container text-right">
                  <button class="js-view-trigger btn-text d-show" type="button" @click="onClickShowMoreAssets()">
                    もっと見る
                  </button>
                </div>
              </template>
              <template v-else>
                <div v-for="asset in challenge.asset_masters" :key="asset.asset_master_id" class="task-labels">
                  <p class="task-labels-parent">
                    {{ asset.name }}
                  </p>
                </div>
              </template>
            </dd>
          </dl>

          <!-- チャレンジのステージ -->
          <dl class="reading-item">
            <dt>このチャレンジのステータス</dt>
            <dd>
              <div class="status-list">

                <!-- アイデア段階 -->
                <div class="status-item">
                  <div v-if="challenge.is_idea_stage">
                    <p class="status-label active">アイデア段階</p>
                    <div class="img-box"><img src="~images/status_img1_on.svg" alt=""></div>
                  </div>
                  <div v-else>
                    <p class="status-label">アイデア段階</p>
                    <div class="img-box"><img src="~images/status_img1.svg" alt=""></div>
                  </div>
                </div>

                <!-- PoC段階 -->
                <div class="status-item">
                  <div v-if="challenge.is_poc_stage">
                    <p class="status-label active">PoC段階</p>
                    <div class="img-box"><img src="~images/status_img2_on.svg" alt=""></div>
                  </div>
                  <div v-else>
                    <p class="status-label">PoC段階</p>
                    <div class="img-box"><img src="~images/status_img2.svg" alt=""></div>
                  </div>
                </div>

                <!-- 事業化段階 -->
                <div class="status-item">
                  <div v-if="challenge.is_commercial_stage">
                    <p class="status-label active">事業化段階</p>
                    <div class="img-box"><img src="~images/status_img3_on.svg" alt=""></div>
                  </div>
                  <div v-else>
                    <p class="status-label">事業化段階</p>
                    <div class="img-box"><img src="~images/status_img3.svg" alt=""></div>
                  </div>
                </div>

                <!-- その他 -->
                <div class="status-item">
                  <div v-if="challenge.is_other_stage">
                    <p class="status-label active">その他</p>
                    <div class="img-box"><img src="~images/status_img4_on.svg" alt=""></div>
                  </div>
                  <div v-else>
                    <p class="status-label">その他</p>
                    <div class="img-box"><img src="~images/status_img4.svg" alt=""></div>
                  </div>
                </div>

              </div>
            </dd>
          </dl>

          <dl class="reading-item">
            <dt>企業情報（私たちについて）</dt>
            <dd class="u-pre-wrap" v-text="challenge.ep_company_business_summary"></dd>
          </dl>
        </article>

        <aside class="chapter white-block mb-4">
          <h3 class="chapter-label mb-3">担当者情報</h3>
          <div class="d-flex p-3">
            <!-- チャレンジの担当者イメージ -->
            <img v-if="challenge.is_challenge_manager_image"
              :src="challenge.presigned_challenge_manager_image_url"
              :alt="challenge.presigned_challenge_manager_image_filename"
              class="thumbnail-frame img80"
            />
            <img v-else
              src="~images/ep_user_default.png"
              alt="画像が選択されていません"
              class="thumbnail-frame img80"
            />
            <div class="ml-3">
              <p class="h5">{{ challenge.challenge_manager_name }}</p>
              <p class="text-box mt-1 u-pre-wrap" v-text="challenge.challenge_manager_profile"></p>
            </div>
          </div>
        </aside>
      </section>

      <!-- チャレンジ情報　スポンサー枠-->
      <section v-else class="article-container mt-3">
        <article class="white-block reading-block">
          <div class="reading-visual"><a class="img-box" href="~images/yamanashi/image2.png" data-lightbox="image" data-title="メインビジュアルタイトルが入ります"><img src="~images/yamanashi/image2.png"></a>
            <div class="reading-visual-caption">山梨は、挑戦と近い。未来と近い。</div>
          </div>
          <div class="reading-bar"><small class="reading-date text-secondary">{{ challenge.release_at | format.datetime }}</small></div>
          <h2 class="reading-title">TRY！ YAMANASHI！ 実証実験サポート事業</h2>
          <dl class="reading-body border-bottom">
            <dt>
              <img v-if="challenge.is_challenge_manager_image"
                :src="challenge.presigned_challenge_manager_image_url"
                :alt="challenge.presigned_challenge_manager_image_filename"
                class="thumbnail-frame img40"
              />
              <img v-else
                src="~images/ep_user_default.png"
                alt="画像が選択されていません"
                class="thumbnail-frame img40"
              />
            </dt>
            <dd>
              <p class="company-name">{{ challenge.ep_company_name_department_name }}</p>
            </dd>
          </dl>
          <section class="article-body">
            <div class="article-lead">
山梨県では官民が一体となって、革新的なビジネスモデルを持つスタートアップ企業を輩出するためのエコシステムの整備に力を入れています。その一つが、同県で行う実証実験を全面的にサポートする「TRY！ YAMANASHI！ 実証実験サポート事業」。2022年度にスタートし、これまで5期で39社のプランを採択、支援を行っています。
<br /><br />
この度、令和5年度第6期の採択企業の募集受付を開始いたしましたので、これまでの実績とともに本事業にご応募いただく際のメリットをご案内いたします。
</div>
            <h3>山梨県だからこそ提供できるアセットを使ってスタートアップの成長を後押し</h3>
            <p>山梨県はリニア開通により都市部との住民の往来が増える見込みがあること、山梨県内にライフサイエンス系の産業集積（メディカル・デバイス・コリドー）が形成されていることから、これらの特性を活かした実証フィールドの提供が可能です。また、山梨県ならではの社会課題も存在しており、これまで採択してきたスタートアップ企業は山梨県民や県内企業の課題解決に取り組んできました。</p>
<p>例えば、患者向けの往診サービスを行っているファストドクターは、主に山梨県内の無医地区・準無医地区の住民に対し、夜間のオンライン診療を実施、重症患者に対してはファストドクターが救急連携や救急病院への受診調整を行う取り組みを実施。地理的な特性上、医師の偏在が問題となっている山梨県だからこそできる実証を行いました。</p>
            <figure class="img-box figure-center">
              <a class="img-box" href="~images/yamanashi/image5.png" data-lightbox="image" data-title="" style="height: 70%;margin: 0 auto;">
                <img src="~images/yamanashi/image5.png">
              </a>
              <figcaption class="reading-visual-caption">山梨県独自のスタートアップエコシステムを形成し、スタートアップを後押し</figcaption>
            </figure>
            <h3>実証実験をきっかけに大きく飛躍する会社も登場</h3>
            <p>本事業は、県内企業や大学などを巻き込んだ支援体制によって、スタートアップを存在感のある企業へと成長を促すのが目的です。従って、医療・ライフサイエンスの他、物流、シニア・介護など山梨県だけでなく全国の自治体で共通課題となっているテーマにも注力しています。</p>
            <p>物流専用ドローンを展開する株式会社エアロネクストがセイノーホールディングス株式会社と連携し、人口が約700人、高齢化率が46％、村内商店が2店舗という小菅村で進めているのは、新スマート物流プロジェクト。ラストワンマイルの起点となる拠点を設置し、ここからドローンや車などを使って住民へ届けられます。</p>
            <p>23年10月に米国証券取引所NASDAQに上場したA.L.I.Technologiesは日本初の空飛ぶバイクを開発するスタートアップ。山梨県内における災害時における移動手段としてエアモビリティを社会実装するための支援を山梨県と共同で取り組んでいます。具体的には、山梨県北杜市に空のインフラの核となる「空の駅」を整備し、その間を結ぶ飛行航路の確立に取り組んでいます。機体の制御や管理はA.L.I.の運行管理システムを活用することで、民間事業者でもドローンシェアリングの体制に参画できる体制構築を行っています。</p>
            <figure class="img-box figure-center">
              <a class="img-box" href="~images/yamanashi/image6.png" data-lightbox="image" data-title="" style="height: 70%;">
                <img src="~images/yamanashi/image6.png">
              </a>
              <figcaption class="reading-visual-caption">山梨県をテストベッドの聖地に</figcaption>
            </figure>
            <p>U3イノベーションズ合同会社は、電気や水道など既存のインフラに接続しないオフグリッドによる住環境の実現に向け、設備の最適運用モデル構築に取り組んでおります。</p>
            <h3>伴走支援やアドバイスだけでなく補助金も提供</h3>
            <p>このように過去に採択してきたスタートアップ企業様に対しては、山梨県内で実証実験を行う際に必要な予算を山梨県から提供させていただくため、最大750万円（補助率4分の3）の経費支援を行っております。</p>
            <figure class="img-box figure-center">
              <a class="img-box" href="~images/yamanashi/image1.png" data-lightbox="image" data-title="" style="height: 70%;">
                <img src="~images/yamanashi/image1.png">
              </a>
              <figcaption class="reading-visual-caption">山梨県HPより</figcaption>
            </figure>
            <div class="gray-box">
              <p><strong>ぜひ令和5年度第6期にご応募ください！</strong></p>
              <p>このチャレンジで紹介した領域の他にも、アグリテックやクリーンエネルギーなどを注力のテーマとしております。本取り組みにご興味をお持ちいただけた方は、本チャレンジへの「興味あり」をお願いいたします。</p>
              <p>「興味あり」を押した会社様には、山梨県より、今期申込のご案内をsixbrainを通じてご案内させていただくほか、希望される企業様には県職員による個別相談会のご案内を予定しております。</p>
              <p>以上</p>
            </div>
          </section>
        </article>
      </section>


      <!-- 企業の他のチャレンジ情報 -->
      <section v-if="!!other_challenges" class="chapter white-block">
        <h2 class="chapter-label mb-3">その他のチャレンジ情報</h2>
        <div class="m-3 p-3">
          <SlickCarousel v-bind="slickOptions" v-if="Object.keys(other_challenges).length" class="other-item-list">
            <li v-for="other_challenge in other_challenges" :key="other_challenge.id">
              <a @click.prevent.stop="onClickOtherChallenge(other_challenge)" href="#" class="card">
                {{ other_challenge.title }}
                <div class="img-box">
                  <img v-if="other_challenge.presigned_other_challenge_main_image_url"
                    :src="other_challenge.presigned_other_challenge_main_image_url"
                    :alt="other_challenge.presigned_other_challenge_main_image_filename"
                  />
                  <img v-else
                    src="~images/image_default.jpg"
                    alt="デフォルト画像"
                  />
                </div>
              </a>
            </li>
          </SlickCarousel>
        </div>
      </section>

      <!-- 戻るボタンエリア-->
      <div class="btn-container d-flex justify-content-center">
        <button class="btn btn-big btn-white rounded-pill" type="button" @click="backToPage()">もどる</button>
      </div>

    </main>

    <!-- 興味あり-->
    <div class="fixed-btn-container-bottom">
      <div class="inner">
        <!-- 興味ありを押している時は「active」クラスを付けてください-->
        <template v-if="challenge.is_interested">
          <button @click="onInterest()" class="button-square btn-block button-like active" type="button"><i class="far fa-thumbs-up"></i><span>取り消し</span></button>
        </template>
        <template v-else>
          <button @click="onInterest()" class="button-square btn-block button-like" type="button"><i class="far fa-thumbs-up"></i><span>興味あり</span></button>
        </template>
      </div>
    </div>

    <div class="btn-container-under"><a href="#" @click.prevent.stop="onLikeHelp()"><i class="fas fa-info-circle mr-1"></i><span>興味ありって？</span></a></div>
    <!-- 興味あり-->

    <FooterComponent />

    <!-- ガイド-->
    <b-modal
      v-model="like_send_help"
      id="guide"
      aria-labelledby="guide-Label"
      title="興味ありって？"
      centered
      hide-header
      hide-footer
      size="sm"
      :no-fade="isNoFade"
    >
      <div class="modal-body">
        <h3 class="chapter-label mb-3"><i class="fas fa-info-circle mr-1"></i>興味ありって？</h3>
        <div class="mx-auto">
          <div class="img-box"><img src="~images/like.svg" alt=""></div>
        </div>
        <div class="my-3">
          <p class="text-box mt-1">気になった案件に対して「興味あり」登録をすることで、企業からのオファーを受け取る可能性が高くなります。気軽に「興味あり登録」をしてみましょう！</p>
        </div>
        <div class="text-center">
          <button type="button" data-dismiss="modal" @click="onLikeHelpHide()"><i class="fas fa-times"></i></button>
        </div>
      </div>
    </b-modal>
    <!-- / ガイド-->

    <!-- 興味あり-->
    <b-modal
      v-model="show_like_modal"
      id="like"
      aria-labelledby="like-Label"
      title="興味あり"
      centered
      hide-header
      hide-footer
      size="sm"
      :no-fade="isNoFade"
    >
      <div>
        <p class="mt-3 text-center">興味ありを有難うございます！<br>こちらの企業様へ貴社の情報をお届けします。<br>企業様よりオファーが届いた際は<br>通知が届きますので宜しくお願いします。</p>
      </div>
      <div class="modal-footer">
        <button class="btn btn-cancel" type="button" @click="backToPage()">チャレンジ一覧に戻る</button>
      </div>
    </b-modal>
    <!-- / 興味あり-->

  </div>
</template>

<script>
import FooterComponent from '../../../common/layouts/footer';
import SlickCarousel from "../../../common/SlickCarouselMixin"
import ScrollMixin from '../../../common/ScrollMixin'

export default {
  components: {FooterComponent},

  mixins: [SlickCarousel, ScrollMixin],

  metaInfo: {
    title: 'チャレンジ情報閲覧',
  },

  data() {
    return {
      challenge_id: this.$route.params.challenge_id,
      challenge: {},
      other_challenges: {},
      previous_challenge_id: null,
      show_like_button: false,
      show_like_modal: false,
      like_send_help: false
    }
  },

  props: { isNoFade: Boolean },

  // メソッド定義
  methods: {
    // データ取得処理
    getChallenge() {
      this.$loading.load(
        this.$auth.api.get(
          'su/challenges/' + this.challenge_id, {
            params: {}
          }
        ).then(res => {
          this.challenge = res.data.challenge;
          this.other_challenges = res.data.other_challenges;
        }).catch(err => {
          this.$errorHandlers.initial(err);
        })
      )
    },

    // 他チャレンジ押下時
    onClickOtherChallenge(other_challenge) {
      this.challenge_id = other_challenge.id
      let resolvedRoute = this.$router.resolve({
          name: 'SuChallengeShow',
          params: {challenge_id: other_challenge.id}
        });
      window.open(resolvedRoute.href)
    },

    // 興味ありボタン押下
    onInterest() {
      // このチャレンジがすでに興味あり済みか
      if (this.challenge.is_interested) {
        // 興味なし→あり
        this.deleteInterest();
      } else {
        // 興味あり→なし
        this.insertInterest();
      }
    },

    // レコード追加リクエスト
    insertInterest() {
      this.$loading.load(
        this.$auth.api.post(`/su/challenges/register_interest`, {id: this.challenge.id}
        ).then(res => {
          this.challenge.is_interested = !this.challenge.is_interested;
          this.show_like_modal = true;
        }).catch(err => {
          if (err.response.status == 500) {
            this.$errorHandlers.initial(err);
          } else {
            this.$errorHandlers.ajax(err);
          }
        })
      )
    },

    // レコード削除リクエスト
    deleteInterest() {
      this.$loading.load(
        this.$auth.api.delete(`/su/challenges/${this.challenge.id}/delete_interest`
        ).then(res => {
          this.challenge.is_interested = !this.challenge.is_interested;
          this.show_like_modal = false;
        }).catch(err => {
          if (err.response.status == 500) {
            this.$errorHandlers.initial(err);
          } else {
            this.$errorHandlers.ajax(err);
          }
        })
      )
    },

    // 戻るボタン
    // 一覧→詳細　一覧に遷移
    // 詳細→詳細　一個前の詳細に遷移
    backToPage() {
      if (!!history.back()) {
        history.back();
      } else {
        this.$router.push({name: 'SuChallengeIndex'})
      }
    },

    // リコメンド対応とはモーダル
      onLikeHelp() {
        this.like_send_help = true;
      },

      // リコメンド対応とはモーダル閉じる
      onLikeHelpHide() {
        this.like_send_help = false;
      },

    // もっと見るボタン押下時
    onClickShowMoreAssets(){
      this.challenge.is_show_more_assets = false;
    },
  },

  // インスタンス生成後、リアクティブデータ初期化後
  created() {
    if (!!this.challenge_id) {
      this.getChallenge();
    }
  },

  // route.push時に実行
  beforeRouteUpdate(to, from, next) {
    this.previous_challenge_id = from.params.challenge_id
  },

  //Scroll時のイベント
  onScroll() {
    this.show_like_button = (window.scrollY > 400);
  }
}
</script>
<style>
.lb-nav a.lb-prev, .lb-nav a.lb-next {
  width: 50%;
}
.fadeIn {
  animation: fadeIn 0.4s;
}
</style>